/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Export_TitleInputs */

const en_preset_manager_export_title = /** @type {(inputs: Preset_Manager_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export this preset`)
};

const fr_preset_manager_export_title = /** @type {(inputs: Preset_Manager_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter ce preset`)
};

const de_preset_manager_export_title = /** @type {(inputs: Preset_Manager_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Voreinstellung exportieren`)
};

const it_preset_manager_export_title = /** @type {(inputs: Preset_Manager_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta questo preset`)
};

const ru_preset_manager_export_title = /** @type {(inputs: Preset_Manager_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт этого пресета`)
};

const es_preset_manager_export_title = /** @type {(inputs: Preset_Manager_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar este ajuste preestablecido`)
};

const zh_cn2_preset_manager_export_title = /** @type {(inputs: Preset_Manager_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出此预设`)
};

const ja_preset_manager_export_title = /** @type {(inputs: Preset_Manager_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプリセットをエクスポート`)
};

const hi_preset_manager_export_title = /** @type {(inputs: Preset_Manager_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस प्रीसेट को निर्यात करें`)
};

const pt_pt2_preset_manager_export_title = /** @type {(inputs: Preset_Manager_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporte esta predefinição.`)
};

/**
* | output |
* | --- |
* | "Export this preset" |
*
* @param {Preset_Manager_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_export_title = /** @type {((inputs?: Preset_Manager_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_export_title(inputs)
	if (locale === "de") return de_preset_manager_export_title(inputs)
	if (locale === "it") return it_preset_manager_export_title(inputs)
	if (locale === "ru") return ru_preset_manager_export_title(inputs)
	if (locale === "es") return es_preset_manager_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_export_title(inputs)
	if (locale === "ja") return ja_preset_manager_export_title(inputs)
	if (locale === "hi") return hi_preset_manager_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_export_title(inputs)
	return en_preset_manager_export_title(inputs)
});